import ModelBase, {IModelBase} from '@/models/ModelBase'
import { KeyPair } from '@/types/KeyPair'

export interface IFavoriteRecruit extends IModelBase {
  user_id: number
  recruit_id: number
}

export class FavoriteRecruit extends ModelBase {
  user_id: number
  recruit_id: number

  constructor(defaults?: IFavoriteRecruit) {
    super(defaults)
    if (defaults) {
      this.user_id = defaults.user_id
      this.recruit_id = defaults.recruit_id
    }
  }

  toParams(): KeyPair {
    return {
      user_id: this.user_id,
      recruit_id: this.recruit_id
    }
  }
}
